import styled from 'styled-components';

export const DocumentsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const IlumaTitle = styled.h4`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 10px;

  .MuiIconButton-root {
    padding: 6px;
  }

  .MuiSvgIcon-root {
    font-size: 22px;
  }
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;

  .title {
    font-weight: 400;
    width: 150px;
    font-size: 14px;
    color: #252733;
    margin: 0;
  }

  .icon {
    &.approved {
      color: #29CC97;
    }

    &.rejected {
      color: #FF6565;
    }

    .MuiSvgIcon-root {
      font-size: 20px;
    }
  }
`;
